<template>
  <v-container fluid>
    <template>
      <v-container fluid>
        <v-expansion-panels flat style="border: 1px solid #0482fb">
          <v-expansion-panel class="elevation-0">
            <v-expansion-panel-header>
              Tri / Recherche ...
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row>
                <v-col cols="12" md="3">
                  <v-text-field
                    outlined
                    color="#0482fb"
                    label="Numéro dossier ..."
                    class="pt-5 pa-2 mx-2 ml-1"
                    v-model="sercheModel.fileNumber"
                    prepend-inner-icon="mdi-magnify"
                    dense
                    flat
                    background-color="grey lighten-4"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field
                    outlined
                    color="#0482fb"
                    label="Emetteur ..."
                    class="pt-5 pa-2 mx-2"
                    v-model="sercheModel.transmitter"
                    prepend-inner-icon="mdi-magnify"
                    dense
                    flat
                    background-color="grey lighten-4"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                  <v-select
                    outlined
                    :items="userNameList"
                    class="pt-5 pa-2 mx-2"
                    prepend-inner-icon="mdi-magnify"
                    dense
                    v-model="sercheModel.agent"
                    flat
                    background-color="grey lighten-4"
                    label="Agent ... "
                  ></v-select>
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field
                    outlined
                    color="#0482fb"
                    label="N° courrier arrivée"
                    class="pt-5 pa-2 mx-2"
                    v-model="sercheModel.mailNumber"
                    prepend-inner-icon="mdi-magnify"
                    dense
                    flat
                    background-color="grey lighten-4"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field
                    outlined
                    color="#0482fb"
                    label="Debut date arrivée courrier début..."
                    class="pt-5 pa-2 mx-2"
                    prepend-inner-icon="mdi-magnify"
                    dense
                    type="date"
                    v-model="sercheModel.startDate"
                    flat
                    background-color="grey lighten-4"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field
                    outlined
                    color="#0482fb"
                    label="Debut date arrivée courrier fin..."
                    class="pt-5 pa-2 mx-2"
                    prepend-inner-icon="mdi-magnify"
                    dense
                    type="date"
                    v-model="sercheModel.endDate"
                    flat
                    background-color="grey lighten-4"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field
                    outlined
                    color="#0482fb"
                    label="Numéro courrier départ ..."
                    class="pt-5 pa-2 mx-2"
                    prepend-inner-icon="mdi-magnify"
                    dense
                    v-model="sercheModel.outgoingMailNumber"
                    flat
                    background-color="grey lighten-4"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                  <v-select
                    outlined
                    :items="items"
                    class="pt-5 pa-2 mx-2"
                    prepend-inner-icon="mdi-magnify"
                    dense
                    v-model="sercheModel.service"
                    flat
                    background-color="grey lighten-4"
                    label="Services ... "
                  >
                  </v-select>
                </v-col>
                <v-col cols="12" md="3">
                  <v-select
                    outlined
                    :items="natureMails"
                    class="pt-5 pa-2 mx-2"
                    prepend-inner-icon="mdi-magnify"
                    dense
                    v-model="sercheModel.nature"
                    flat
                    background-color="grey lighten-4"
                    label="Nature ... "
                  ></v-select>
                </v-col>
                <v-col cols="12" md="3">
                  <v-autocomplete
                    outlined
                    :items="userFile"
                    class="pt-5 pa-2 mx-2"
                    prepend-inner-icon="mdi-magnify"
                    v-model="sercheModel.file"
                    dense
                    flat
                    background-color="grey lighten-4"
                    label="Nom raison social"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" md="3">
                  <v-autocomplete
                    outlined
                    :items="productNameList"
                    class="pt-5 pa-2 mx-2"
                    prepend-inner-icon="mdi-magnify"
                    dense
                    v-model="sercheModel.product"
                    flat
                    background-color="grey lighten-4"
                    label="produit"
                  >
                  </v-autocomplete>
                </v-col>
              </v-row>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="#0482fb"
                  pill
                  class="mr-2 white--text"
                  @click="onEnter"
                >
                  <v-icon left> mdi-magnify </v-icon>
                  Appliquer la recherche
                </v-btn>
              </v-card-actions>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-container>
      <v-dialog v-model="addFileMailGed" max-width="900px">
        <v-card style="border-top: 10px solid #0482fb">
          <v-card-title>
            <span
              class="text-h4 mb-5 mt-5"
              style="color: #0482fb; font-weight: bold"
              >Gestionnaire de fichier</span
            >
          </v-card-title>
          <v-item-group multiple>
            <v-container>
              <!-- {{filesListe}} -->
              <v-row>
                <v-col v-for="n in filesListe" :key="n" cols="12" md="4">
                  <v-item>
                    <v-card
                      style="border: 2px solid #0482fb"
                      class="d-flex align-center"
                      height="250"
                    >
                      <v-card-text style="height: 100px; position: relative">
                        <h4 style="text-align: center">
                          {{ n.filename }}
                        </h4>
                        <v-fab-transition>
                          <v-btn
                            class="white--text mt-10"
                            color="#0482fb"
                            :href="n.path"
                            target="_blank"
                            dark
                            absolute
                            route
                            bottom
                            right
                            fab
                          >
                            <v-icon target="_blank" route :href="n.path"
                              >mdi-download</v-icon
                            >
                          </v-btn>
                        </v-fab-transition>
                      </v-card-text>
                    </v-card>
                  </v-item>
                </v-col>
              </v-row>
            </v-container>
          </v-item-group>
        </v-card>
      </v-dialog>
      <v-toolbar flat>
        <h4 class="text-h4 pageTitle">Suivi des courriers</h4>

        <v-divider class="mx-4" inset vertical></v-divider>
        <v-switch
          v-model="showAllFil"
          label="Afficher toutes les données"
          color="#0482fb"
          @change="showAllFillData"
          class="pt-5"
        ></v-switch>
        <v-spacer></v-spacer>

        <v-dialog v-model="dialogDelete" max-width="500px">
          <v-card>
            <v-card-title class="text-h5"
              >Etes vous sûrs de vouloire supprimer cet élément ?</v-card-title
            >
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="closeDelete"
                >Cancel</v-btn
              >
              <v-btn color="blue darken-1" text @click="deleteItemConfirm"
                >OK</v-btn
              >
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>

      <v-data-table
        :headers="headers"
        flat
        :loading="loading ? '#0482fb' : null"
        :items="GlobalMails.docs"
      >
        <template v-slot:top>
          <v-toolbar class="ml-0 pl-0" flat>
            <v-dialog v-model="dialog" max-width="1000px">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="#0482fb"
                  dark
                  class="mb-2"
                  v-bind="attrs"
                  @click="initAll()"
                  v-on="on"
                >
                  Ajouter nouveau courrier
                </v-btn>
              </template>
              <v-card style="border-top: 10px solid #0482fb">
                <v-card-title>
                  <span
                    class="text-h4 mb-5 mt-5"
                    style="color: #0482fb; font-weight: bold"
                    >Courrier</span
                  >
                </v-card-title>

                <v-card-text>
                  <v-row>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field
                        outlined
                        color="#0482fb"
                        background-color="#cbf3f0"
                        v-model="mailModal.fileNumber"
                        label="Numéro dossier"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field
                        outlined
                        color="#0482fb"
                        v-model="mailModal.transmitter"
                        label="Emetteur"
                      >
                      </v-text-field>
                    </v-col>

                    <v-col cols="12" sm="6" md="4">
                      <v-text-field
                        disabled
                        outlined
                        color="#0482fb"
                        background-color="#cbf3f0"
                        v-model="mailModal.mailNumber"
                        label="Numéro courrier arrivée"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="8" md="8">
                      <v-combobox
                        outlined
                        v-model="mailModal.agent"
                        :items="userNameList"
                        label="Agent"
                        multiple
                      >
                        <!-- <template v-slot:selection="data">
                            <v-chip :key="JSON.stringify(data.item)" v-bind="data.attrs" :input-value="data.selected"
                              :disabled="data.disabled" @click:close="data.parent.selectItem(data.item)">
                              <v-avatar class="accent white--text" left
                                v-text="data.item.slice(0, 1).toUpperCase()"></v-avatar>
                              {{ data.item }}
                            </v-chip>
                          </template> -->
                      </v-combobox>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-select
                        outlined
                        :items="['OUI', 'NON']"
                        v-model="etatMail"
                        color="#0482fb"
                        @change="mailSend"
                        label="Notifier Agents ( Mail )"
                      ></v-select>
                    </v-col>

                    <v-col cols="12" sm="6" md="4">
                      <v-autocomplete
                        :items="userFile"
                        v-model="file"
                        color="#0482fb"
                        clearable
                        outlined
                        deletable-chips
                        @change="mailSend"
                        label="Nom raison social"
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field
                        outlined
                        color="#0482fb"
                        v-model="mailModal.receptionDate"
                        label="Date arrivée"
                        type="date"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field
                        outlined
                        color="#0482fb"
                        v-model="mailModal.assignmentDate"
                        label="Date affectation"
                        type="date"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field
                        outlined
                        color="#0482fb"
                        v-model="mailModal.treatmentDate"
                        label="Date traitement"
                        type="date"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field
                        outlined
                        color="#0482fb"
                        v-model="mailModal.outgoingMailNumber"
                        label="Numéro courrier départ"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-select
                        outlined
                        v-model="mailModal.service"
                        :items="items"
                        label="Service"
                      ></v-select>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-autocomplete
                        outlined
                        v-model="mailModal.nature"
                        background-color="#cbf3f0"
                        :items="natureMails"
                        label="Nature courrier"
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-select
                        outlined
                        v-model="mailModal.product"
                        background-color="#cbf3f0"
                        :items="productNameList"
                        label="Produit"
                      ></v-select>
                    </v-col>
                    <v-col cols="6" md="4">
                      <v-file-input
                        outlined
                        v-model="mailModal.files"
                        label="Ajouter les fichiers "
                        counter
                        multiple
                        show-size
                        truncate-length="50"
                      ></v-file-input>
                    </v-col>
                    <v-col cols="6">
                      <v-textarea
                        outlined
                        v-model="mailModal.CEOInstruction"
                        name="input-7-4"
                        rows="3"
                        label="Instruction"
                      ></v-textarea>
                    </v-col>
                    <v-col cols="6">
                      <v-textarea
                        outlined
                        v-model="mailModal.observation"
                        rows="3"
                        name="input-7-4"
                        label="Tâches éffectuées"
                      ></v-textarea>
                    </v-col>
                  </v-row>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="error " text @click="dialog = false">
                    Fermer
                  </v-btn>
                  <v-btn
                    :loading="loading ? '#0482fb' : null"
                    color="success"
                    :disabled="loading"
                    @click="addMailFormModal()"
                  >
                    Enregistrer le courrier
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <v-spacer></v-spacer>
          </v-toolbar>
        </template>
        <template v-slot:item="{ item }">
          <tr @click="handleClick(item)" class="green-bg">
            <td>
              {{ item.actions }}
              <v-menu elevation="0" right offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon v-bind="attrs" v-on="on" class="mr-10">
                    <v-icon color="success" size="30">mdi-forwardburger</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-tooltip bottom color="warning">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn class="ml-3" icon>
                        <v-icon
                          size="20"
                          @click="handleClick(item)"
                          v-bind="attrs"
                          v-on="on"
                          color="warning"
                        >
                          mdi-file-edit-outline</v-icon
                        >
                      </v-btn>
                    </template>
                    <span>Modifier le dossier</span>
                  </v-tooltip>
                  <v-tooltip bottom color="success">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn class="ml-3" icon>
                        <v-icon
                          size="20"
                          @click="handleClickMailGed(item)"
                          color="success"
                          v-bind="attrs"
                          v-on="on"
                        >
                          mdi-file-document-multiple-outline</v-icon
                        >
                      </v-btn>
                    </template>
                    <span>Gestion des fichiers </span>
                  </v-tooltip>

                  <!-- <v-tooltip bottom color="grey darken-4">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn class="ml-3" icon>
                          <v-icon
                            size="20"
                            color="grey darken-4"
                            v-bind="attrs"
                            v-on="on"
                            @click="medicalReport(item)"
                            >mdi-vector-link</v-icon
                          >
                        </v-btn>
                      </template>
                      <span>Rapport d'expertise médical</span>
                    </v-tooltip> -->
                </v-list>
              </v-menu>
            </td>
            <td>
              <v-chip :color="getColor(item.nature)" dark>
                {{ item.nature }}
              </v-chip>
            </td>
            <td>
              {{ item.fileNumber }}
            </td>

            <td>
              {{
                typeof item.file === "object" && item.file !== null
                  ? item.file.name
                  : getName(item.file)
              }}
            </td>
            <td>{{ item.product }}</td>
            <td>{{ item.transmitter }}</td>
            <td>{{ item.agent ? item.agent.toString() : "" }}</td>
            <td>{{ item.mailNumber }}</td>
            <td>{{ item.receptionDateFr }}</td>
            <td>
              {{ new Date(item.createdAt).toLocaleString() }}
            </td>
            <td>{{ item.assignmentDateFr }}</td>
            <td>{{ item.treatmentDateFr }}</td>
            <td>{{ item.outgoingMailNumber }}</td>
            <td>{{ item.service }}</td>
            <td>{{ item.CEOInstruction }}</td>
            <td>{{ item.observation }}</td>
          </tr>
        </template>

        <template v-slot:item.actions="{ item }">
          <v-icon color="warning" size="30" @click="editItem(item)">
            mdi-pencil-box-multiple-outline
          </v-icon>
        </template>
      </v-data-table>
    </template>
  </v-container>
</template>

<script>
import { defaultMethods, messages } from "@/utils/data";
import { mapActions, mapGetters } from "vuex";
import { updateGlobalMail, createGlobalMail } from "@/api/user.js";
export default {
  name: "production",
  components: {},
  data: () => ({
    loading: false,
    dialog: false,
    filesListe: [],
    productNameList: [],
    addFileMailGed: false,
    sercheModel: {
      fileNumber: "",
      mailNumber: "",
      transmitter: "",
      switch1: true,
      agent: "",
      file: "",

      receptionStartDate: "",
      receptionEndDate: "",
      treatmentDate: "",
      assignmentDate: "",
      service: "",
    },
    natureMails: [
      "Accord",
      "Accord Sinistre",
      "Actualisation",
      "AIB",
      "Annonce",
      "Attestation",
      "Attestation + Facture",
      "Attestation de Bonne fin d'exécution",
      "Audit",
      "Autre",
      "Avenant",
      "Avenant de changement de Véhicule",
      "Avenant de changement d'immatriculation",
      "Avenant de Modification",
      "Avenant de précision",
      "Avenant de Régulatisation",
      "Avenant de renouvellement",
      "Avenant de résiliation",
      "Avenant de Retrait",
      "Avenant de retrait + Incorporation",
      "Avenant de suspension",
      "Avenant d'incorporation",
      "Avenant d'incorporation + Retrait",
      "Avis",
      "Avis d'aliment",
      "Avis de recouvrement",
      "Avis de redressement",
      "Avis d'échéance",
      "Avis d'imposition",
      "BIA",
      "Bon d'analyse",
      "Bon de commande",
      "Bon de Prise En Charge",
      "Bon de réception",
      "Bon de travail",
      "Bordereau",
      "BPEC (Bon de Prise en Charge)",
      "Candidature spontanée",
      "Carte en stock",
      "Demande de spécimen",
      "Point des fiches en stock",
      "Sortie de fiches",
      "Fonds de roulement Assureur",
      "Fonds de roulement Auto-fi",
      "Rapprochement Assureur",
      "Transmission statistiques Assureur",
      "Transmission statistiques Autofi",
      "Reporting",
      "Mise à jour groupe whatsapp RH",
      "Mise à jour groupe whatsapp Prestataires",
      "Mise à jour groupe mail-liste RH",
      "Mise à jour groupe mail-liste Prestataires",
      "Plaintes",
      "Lettre de rejet",
      "Synthèse et Bilan Santé",
      "Point retour signé",
      "Mise à jour contacts",
      "Mise à jour adresse Mail",
      "Mise à jour Contact whatsapp",
      "mise à jour Adresse promoteur",
      "Mise à jour Agent du Prestataire",
      "Réception Géolocalisation",
      "Mise à jour convention",
      "Signature convention",
      "Collage des autocolants",
      "Fourniture Fiche de soin",
      "Point fiches de soin",
      "Installation de la plateforme Prestataire",
      "Installation de la plateforme client",
      "Reception Liste Docteur",
      "Réception liste Agents",
      "Réception Grille tarifaire",
      "Reversement Grille tarifaire",
      "Actualisation RIB",
      "Formation",
      "Actualisation N° de transfert",
      "Mise à jour du reseau de soin",
      "Impression reseau de soin",
      "Prestataire utlisant le Logiciel",
      "Parametrage",
      "Rapprochement",
      "Conception tableau de garantie",
      "Carte de présentation",
      "Carte de visite",
      "Cathalogue",
      "Certificat",
      "Certificat Médical",
      "Changement",
      "Chèque",
      "Communication",
      "Compte-rendu",
      "Condition Générale",
      "Condition Particulière",
      "Confirmation de solde",
      "Contrat",
      "Convention",
      "Convocation",
      "Copie d'attestation",
      "Courrier",
      "CV",
      "Décharge",
      "Déclaration",
      "Délégation",
      "Délégation d'indemnité",
      "Demande",
      "Demande AIB",
      "Demande d'agrément",
      "Demande d'annulation",
      "Demande d'attestation",
      "Demande d'Audience",
      "Demande de contrat",
      "Demande de correction",
      "Demande de correction de carte",
      "Demande de Cotation",
      "Demande de Don",
      "Demande de duplicata",
      "Demande de liste",
      "Demande de mise à Jour",
      "Demande de paiement",
      "Demande de quittance",
      "Demande de rachat",
      "Demande de radiation",
      "Demande de remboursement",
      "Demande de rendez-vous",
      "Demande de retrait",
      "Demande de RIB",
      "Demande de Sponsoring",
      "Demande de stage",
      "Demande de subvention",
      "Demande d'émission de carte",
      "Demande d'emploi",
      "Demande d'expertise",
      "Demande d'explication",
      "Demande d'extraction",
      "Demande d'incorporation",
      "Demande d'incorporation + Retrait",
      "Demande d'information",
      "Devis",
      "Document",
      "Enquête",
      "Enquête de satisfaction",
      "Etude",
      "Evénement",
      "Explication",
      "Facture",
      "Fiscalité",
      "Formation",
      "Impôt",
      "Information",
      "Invitation",
      "Lettre",
      "Lettre de mission",
      "Lettre explicative",
      "Liquidation",
      "Liquidation judiciaire",
      "Liste",
      "Liste actualisée",
      "Mandat",
      "Mandat de courtage",
      "Modification",
      "Nbre de lignes saisies",
      "Nomination",
      "Note de débit",
      "Note de Débit / Autofi",
      "Note de Débit / Compagnie",
      "Note explicative",
      "Notification de résultat",
      "Notification d'expertise",
      "Offre",
      "Offre de formation",
      "Offre de service",
      "Offre sinistre",
      "Ordonnance",
      "Ordre",
      "Ordre de virement",
      "Papier",
      "Papier d'achat",
      "Parametrage Lisa",
      "Photo",
      "Pièce comptable",
      "Pièce d'étude",
      "Pièce sinistre Corporel",
      "Pièce sinistre décès",
      "Pièce sinistre matériel",
      "Pièces",
      "Pièces sinistres Matériel & Corporel",
      "Pouvoir",
      "Preuve",
      "Procès verbal",
      "Proformat",
      "Projet",
      "Projet de contrat",
      "Proposition",
      "Quittance",
      "Quittance AIB",
      "Rachat",
      "Rapport",
      "Rapprochement/ comptabilité",
      "Réclamation",
      "Réclamation facture",
      "Réclamation Prestataire",
      "Relance",
      "Remboursement direct",
      "Réponse",
      "Reprise de carte",
      "Résiliation",
      "Résiliation à titre conservatoire",
      "Résiliation pour odre",
      "Retour",
      "Retour avenant signé",
      "Retour contrat  signé",
      "Retour contrat signé",
      "Retour projet signé",
      "Retour signé",
      "Réunion",
      "RIB",
      "Saisie",
      "Signification",
      "Signification de convention de partenariat",
      "Sinistre",
      "Situation fiscale",
      "Sponsoring",
      "Suspension",
      "Tarif",
      "Transmission",
      "Virement de masse",
    ],
    items: [
      "Administration",
      "Commercial",
      "Finance",
      "Production ADP",
      "Production IARD",
      "Sinistre ADP",
      "Sinistre IARD",
      "Service Informatique",
      "Médecins Conseils",
      "Communication",
      "Capital humain",
      "Directon Générale",
    ],
    sinisterDialog: false,
    dialogDelete: false,
    userNameList: [],
    headers: [
      {
        text: "Actions",
        width: "100px",
        align: "left",
        value: "actions",
        sortable: false,
      },
      { text: "Nature courrier", width: "200px", value: "nature" },
      {
        text: "N° Dossier",
        align: "start",
        width: "200px",
        sortable: false,
        value: "fileNumber",
      },
      { text: "Nom raison social", width: "200px", value: "transmitter" },
      { text: "Produit", width: "200px", value: "transmitter" },
      { text: "Emetteur", width: "200px", value: "transmitter" },
      { text: "Agent", width: "200px", value: "agent" },
      { text: "N° courrier arrivée", width: "200px", value: "mailNumber" },
      {
        text: "Date courrier arrivée",
        width: "200px",
        value: "receptionDateFr",
      },
      {
        text: "Date et heure enregistrement courrier",
        width: "300px",
        value: "createdAt",
      },
      { text: "Date affectation", width: "200px", value: "assignmentDateFr" },
      { text: "Date traitemnt", width: "200px", value: "treatmentDateFr" },
      {
        text: "Numéro courrier départ",
        width: "200px",
        value: "outgoingMailNumber",
      },
      { text: "Services", width: "200px", value: "service" },

      { text: "Instruction DG", width: "200px", value: "CEOInstruction" },
      { text: "Observations", width: "200px", value: "observation" },
    ],
    courrierData: [
      {
        fileNumber: "1222336363",
        transmitter: "NSIA",
        agent: "HINSON Elias",
        mailNumber: "2255",
        receptionDate: "22/12/2022",
        outgoingMailNumber: "12/12/2022",
        assignmentDate: "01/12/2022",
        treatmentDate: "01/01/2023",
        service: "Production",
        observation: "Effectuer et recus",
      },
    ],
    editedIndex: -1,
    editedItem: {
      mailModal: {},
    },
    defaultItem: {
      mailModal: {},
    },
    mailModal: {},
  }),

  computed: {
    ...mapGetters(["GlobalMails", "Users", "Files", "Products"]),
    formTitle() {
      return this.editedIndex === -1 ? "Nouveau courrier" : "Modifier Courrier";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    Users() {
      this.userNameList = defaultMethods.getNameList(this.Users.docs);
    },
    Files() {
      this.userFile = defaultMethods.getNameList(this.Files.docs);
    },
    Products() {
      // alert('ok')
      this.productNameList = defaultMethods.getNameList(this.Products.docs);
    },
  },

  mounted() {
    this.initialize();
  },

  methods: {
    ...mapActions([
      "getGlobalMails",
      "postsearchGlobalMail",
      "getUsers",
      "getFiles",
      "getProducts",
    ]),
    showAllFillData() {
      this.initialize();
      //alert(this.showAllFil);
    },
    initAll() {
      this.mailModal = {};
      this.file = "";
      // alert(JSON.stringify(this.mailModal));
      this.etatMail = "";
    },
    async initialize() {
      this.loading = true;
      try {
        await this.getProducts({ name: this.searchData });
        await this.getGlobalMails({ withoutPeriod: this.showAllFil });
        await this.getUsers();
        await this.getFiles({ withoutPeriod: true });
      } catch (error) {
        defaultMethods.dispatchError(
          this.$store,
          messages.failedToLoad("Declaration")
        );
      }
      this.loading = false;
    },
    closeMail() {
      this.dialog = false;
      this.mailModal = Object.assign({}, {});
    },

    editItem(item) {
      this.editedIndex = 1;
      this.mailModal = Object.assign({}, item);
      this.etatMail = "";
      this.dialog = true;
    },

    deleteItem(item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      this.desserts.splice(this.editedIndex, 1);
      this.closeDelete();
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    // Recherche bar
    getName(item) {
      // alert(item)
      if (item != "") {
        return defaultMethods.getItemName(this.Files.docs, item);
      } else {
        console.log("null");
      }
    },
    handleClick(item) {
      // alert(JSON.stringify(item))
      this.mailModal = Object.assign({}, item);
      this.mailModal.files = [];
      this.file = defaultMethods.getItemName(this.Files.docs, item.file);
      // alert(this.mailModal.file)
      this.dialog = true;
    },
    async makesearchGlobalMail() {
      this.loading = true;
      try {
        await this.postsearchGlobalMail({
          mailNumber: this.sercheModel.mailNumber,
          fileNumber: this.sercheModel.fileNumber,
          transmitter: this.sercheModel.transmitter,
          agent: this.sercheModel.agent,
          receptionStartDate: this.sercheModel.startDate,
          receptionEndDate: this.sercheModel.endDate,
          treatmentDate: this.sercheModel.treatmentDate,
          assignmentDate: this.sercheModel.assignmentDate,
          service: this.sercheModel.service,
          nature: this.sercheModel.nature,
          product: this.sercheModel.product,
          fileName: defaultMethods.getItemId(
            this.Files.docs,
            this.sercheModel.file
          ),
        });
      } catch (error) {
        console.log(error);
        defaultMethods.dispatchError(
          this.$store,
          messages.failedToLoad("les courier")
        );
      }
      this.loading = false;
    },
    onEnter: function () {
      this.makesearchGlobalMail();
    },
    getColor(item) {
      if (item == "Accord") return "orange";
      else if (item == "Accord Sinistre") return "#d9ed92";
      else if (item == "Actualisation") return "#d9ed92";
      else if (item == "AIB") return "#168aad";
      else if (item == "Annonce") return "#168aad";
      else if (item == "Attestation") return "#168aad";
      else if (item == "Attestation + Facture") return "#168aad";
      else if (item == "Attestation de Bonne fin d'exécution") return "#168aad";
      else if (item == "Audit") return "#e56b6f";
      else if (item == "Autre ...") return "#e56b6f";
      else if (item == "Avenant") return "#fb8b24";
      else if (item == "Avenant de changement de Véhicule") return "#fb8b24";
      else if (item == "Avenant de changement d'immatriculation")
        return "#fb8b24";
      else if (item == "Avenant de Modification") return "#e71d36";
      else if (item == "Avenant de précision") return "#e71d36";
      else if (item == "Avenant de Régulatisation") return "#e71d36";
      else if (item == "Avenant de renouvellement") return "#e71d36";
      else if (item == "Avenant de résiliation") return "#e71d36";
      else if (item == "Avenant de Retrait") return "#e71d36";
      else if (item == "Avenant de retrait + Incorporation") return "#e71d36";
      else if (item == "Avenant de suspension") return "#e71d36";
      else if (item == "Avenant Incorporation") return "#e71d36";
      else if (item == "Avenant d'incorporation  + Retrait") return "#011627";
      else if (item == "Avis") return "#f72585";
      else if (item == "Avis d'aliment") return "#f72585";
      else if (item == "Avis de recouvrement") return "#f72585";
      else if (item == "Avis de redressement") return "#f72585";
      else if (item == "Avis d'échéance") return "#f72585";
      else if (item == "Avis d'imposition") return "#f72585";
      else if (item == "BIA") return "#43aa8b";
      else if (item == "Bon d'analyse") return "#577590";
      else if (item == "Bon de commande") return "#577590";
      else if (item == "Bon de Prise En Charge") return "#577590";
      else if (item == "Bon de réception") return "#ff6b6b";
      else if (item == "Bon de travail") return "#ff6b6b";
      else if (item == "Bordereau") return "#ff6b6b";
      else if (item == "BPEC (Bon de Prise en Charge)") return "#ff6b6b";
      else if (item == "Certificat") return "#80b918";
      else if (item == "Candidature spontanée") return "#80b918";
      else if (item == "Carte de présentation") return "#80b918";
      else if (item == "Carte de visite") return "#80b918";
      else if (item == "Cathalogue") return "#80b918";
      else if (item == "Certificat") return "#80b918";
      else if (item == "Certificat Médical") return "#003566";
      else if (item == "Changement") return "#003566";
      else if (item == "Chèque") return "#660708";
      else if (item == "Communication") return "#463f3a";
      else if (item == "Compte-rendu") return "#bcb8b1";
      else if (item == "Condition Générale") return "#5f0f40";
      else if (item == "Condition Particulière") return "#5f0f40";
      else if (item == "Confirmation de solde") return "#5f0f40";
      else if (item == "Contrat") return "#5f0f40";
      else if (item == "Convention") return "#0b525b";
      else if (item == "Convocation") return "#001233";
      else if (item == "Copie d'attestation") return "#001233";
      else if (item == "Courrier") return "#ffca3a";
      else if (item == "CV") return "#ffca3a";
      else if (item == "Décharge") return "#8ac926";
      else if (item == "Déclaration") return "#8ac926";
      else if (item == "Délégation") return "#8ac926";
      else if (item == "Demande") return "#8ac926";
      else if (item == "Demande AIB") return "#8ac926";
      else if (item == "Demande d'agrément") return "#1982c4";
      else if (item == "Demande d'annulation") return "#6a4c93";
      else if (item == "Demande d'attestation") return "#abc4ff";
      else if (item == "Demande d'Audience") return "#6f1d1b";
      else if (item == "Demande de contrat") return "#197278";
      else if (item == "Demande de correction") return "#c44536";
      else if (item == "Demande de correction de carte") return "#ff99c8";
      else if (item == "Demande de Cotation") return "#390099";
      else if (item == "Demande de Don") return "#390099";
      else if (item == "Demande de duplicata") return "#390099";
      else if (item == "Demande de liste") return "#390099";
      else if (item == "Demande de mise à Jour") return "#390099";
      else if (item == "Demande de paiement") return "#390099";
      else if (item == "Demande de quittance") return "#390099";
      else if (item == "Demande de rachat") return "#390099";
      else if (item == "Demande de radiation") return "#390099";
      else if (item == "Demande de remboursement") return "#390099";
      else if (item == "Demande de rendez-vous") return "#390099";
      else if (item == "Demande de retrait") return "#390099";
      else if (item == "Demande de RIB") return "#390099";
      else if (item == "Demande de Sponsoring") return "#390099";
      else if (item == "Demande de stage ") return "#390099";
      else if (item == "Demande de subvention") return "#390099";
      else if (item == "Demande d'émission de carte") return "#390099";
      else if (item == "Demande d'emploi") return "#390099";
      else if (item == "Demande d'expertise") return "#390099";
      else if (item == "Demande d'explication") return "#390099";
      else if (item == "Demande d'extraction") return "#390099";
      else if (item == "Demande d'incorporation") return "#390099";
      else if (item == "Demande d'incorporation + Retrait") return "#390099";
      else if (item == "Demande d'information") return "#390099";
      else if (item == "Devis") return "#390099";
      else if (item == "Document") return "#390099";
      else if (item == "Enquête ") return "#390099";
      else if (item == "Enquête de satisfaction") return "#390099";
      else if (item == "Etude") return "#390099";
      else if (item == "Evénement") return "#390099";
      else if (item == "Explication") return "#390099";
      else if (item == "Facture") return "#390099";
      else if (item == "Fiscalité") return "#390099";
      else if (item == "Formation") return "#390099";
      else if (item == "Impôt") return "#390099";
      else if (item == "Information") return "#390099";
      else if (item == "Invitation") return "#390099";
      else if (item == "ettre") return "#390099";
      else if (item == "ettre de mission") return "#390099";
      else if (item == "ettre explicative") return "#390099";
      else if (item == "iquidation") return "#390099";
      else if (item == "iquidation judiciaire") return "#390099";
      else if (item == "iste") return "#390099";
      else if (item == "iste actualisée") return "#390099";
      else if (item == "andat") return "#390099";
      else if (item == "andat de courtage") return "#390099";
      else if (item == "odification") return "#390099";
      else if (item == "Nbre de lignes saisies") return "#390099";
      else if (item == "Nomination") return "#390099";
      else if (item == "Note de débit") return "#390099";
      else if (item == "Note de Débit / Autofi") return "#390099";
      else if (item == "Note de Débit / Compagnie") return "#390099";
      else if (item == "Note explicative") return "#390099";
      else if (item == "Notification de résultat") return "#390099";
      else if (item == "Notification d'expertise") return "#390099";
      else if (item == "Offre") return "#390099";
      else if (item == "Offre de formation") return "#390099";
      else if (item == "Offre de service") return "#390099";
      else if (item == "Offre sinistre") return "#390099";
      else if (item == "Ordonnance") return "#390099";
      else if (item == "Ordre") return "#390099";
      else if (item == "Ordre de virement") return "#390099";
      else if (item == "Papier ") return "#390099";
      else if (item == "Papier d'achat") return "#390099";
      else if (item == "Parametrage Lisa") return "#390099";
      else if (item == "Photo") return "#390099";
      else if (item == "Pièce comptable") return "#390099";
      else if (item == "Pièce d'étude") return "#390099";
      else if (item == "Pièce sinistre Corporel") return "#390099";
      else if (item == "Pièce sinistre décès") return "#390099";
      else if (item == "Pièce sinistre matériel") return "#390099";
      else if (item == "Pièces") return "#390099";
      else if (item == "Pièces sinistres Matériel & Corporel") return "#390099";
      else if (item == "Pouvoir") return "#390099";
      else if (item == "Preuve") return "#390099";
      else if (item == "Procès verbal") return "#390099";
      else if (item == "Proformat") return "#390099";
      else if (item == "Projet ") return "#390099";
      else if (item == "Projet de contrat") return "#390099";
      else if (item == "Proposition") return "#390099";
      else if (item == "Quittance") return "#390099";
      else if (item == "Quittance AIB") return "#390099";
      else if (item == "Rachat") return "#390099";
      else if (item == "Rapport") return "#390099";
      else if (item == "Rapprochement/ comptabilité") return "#390099";
      else if (item == "Réclamation") return "#390099";
      else if (item == "Réclamation facture") return "#390099";
      else if (item == "Réclamation Prestataire") return "#390099";
      else if (item == "Relance") return "#390099";
      else if (item == "Remboursement direct") return "#390099";
      else if (item == "Réponse") return "#390099";
      else if (item == "Reprise de carte") return "#390099";
      else if (item == "Résiliation") return "#390099";
      else if (item == "Résiliation à titre conservatoire") return "#390099";
      else if (item == "Résiliation pour odre") return "#390099";
      else if (item == "Retour") return "#390099";
      else if (item == "Retour avenant signé") return "#390099";
      else if (item == "Retour contrat  signé") return "#390099";
      else if (item == "Retour contrat signé") return "#390099";
      else if (item == "Retour projet signé") return "#390099";
      else if (item == "Retour signé") return "#390099";
      else if (item == "Réunion") return "#390099";
      else if (item == "RIB") return "#390099";
      else if (item == "Saisie") return "#390099";
      else if (item == "Signification") return "#390099";
      else if (item == "Signification de convention de partenariat")
        return "#390099";
      else if (item == "Sinistre") return "#390099";
      else if (item == "Situation fiscale") return "#390099";
      else if (item == "Sponsoring") return "#390099";
      else if (item == "Suspension") return "#390099";
      else if (item == "Tarif") return "#390099";
      else if (item == "Transmission") return "#390099";
      else if (item == "Virement de masse") return "#390099";
      else return "green";
    },
    mailSend() {
      if (this.etatMail == "OUI") {
        this.mailModal.sendEmail = true;
      } else {
        this.mailModal.sendEmail = false;
      }
    },
    async addMailFormModal() {
      this.loading = true;
      // alert(JSON.stringify(this.enquetteurNameList));
      try {
        const formData = new FormData();
        if (this.mailModal.fileNumber) {
          formData.append("fileNumber", this.mailModal.fileNumber);
        }
        if (this.mailModal.mailNumber) {
          formData.append("mailNumber", this.mailModal.mailNumber);
        }
        // if (this.mailModal.fullName) {
        //   formData.append(
        //     "sinisterVictim",
        //     defaultMethods.getItemId(
        //       this.victimeList,
        //       this.mailModal.fullName
        //     )
        //   );
        // }
        if (this.mailModal.agent) {
          formData.append("agent", JSON.stringify(this.mailModal.agent));
        }
        if (this.mailModal.transmitter) {
          formData.append("transmitter", this.mailModal.transmitter);
        }

        // if (this.mailModal.agent) {
        //   for (let i = 0; i < this.mailModal.agent.length; i++) {
        //     formData.append("agent", this.mailModal.agent[i]);
        //   }
        // }
        if (this.mailModal.sendEmail) {
          formData.append("sendEmail", this.mailModal.sendEmail);
        }
        if (this.mailModal.receptionDate) {
          formData.append("receptionDate", this.mailModal.receptionDate);
        }
        if (this.file) {
          formData.append(
            "file",
            defaultMethods.getItemId(
              this.Files.docs,
              typeof this.file === "object" && this.file !== null
                ? this.file.name
                : this.getName(this.file)
            )
          );
        }
        if (this.mailModal.assignmentDate) {
          formData.append("assignmentDate", this.mailModal.assignmentDate);
        }
        if (this.mailModal.treatmentDate) {
          formData.append("treatmentDate", this.mailModal.treatmentDate);
        }
        if (this.mailModal.outgoingMailNumber) {
          formData.append(
            "outgoingMailNumber",
            this.mailModal.outgoingMailNumber
          );
        }
        if (this.mailModal.service) {
          formData.append("service", this.mailModal.service);
        }
        if (this.mailModal.nature) {
          formData.append("nature", this.mailModal.nature);
        }
        if (this.mailModal.CEOInstruction) {
          formData.append("CEOInstruction", this.mailModal.CEOInstruction);
        }
        if (this.mailModal.observation) {
          formData.append("observation", this.mailModal.observation);
        }
        if (this.mailModal.product) {
          formData.append("product", this.mailModal.product);
        }
        if (this.victimeId) {
          formData.append("sinisterVictim", this.victimeId);
        }
        if (this.mailModal.mailDate) {
          formData.append("mailDate", this.mailModal.mailDate);
        }
        if (this.mailModal.agent) {
          // alert(JSON.stringify(this.mailModal.agent))
          formData.append(
            "emails",
            JSON.stringify(
              defaultMethods.getItemsEmail(
                this.Users.docs,
                this.mailModal.agent
              )
            )
          );
        }
        if (this.mailModal.files) {
          for (let i = 0; i < this.mailModal.files.length; i++) {
            formData.append("files", this.mailModal.files[i]);
          }
        }
        // const schema = {
        //   fileNumber: this.mailModal.fileNumber,
        //   mailNumber: this.mailModal.mailNumber,
        //   agent: this.mailModal.agent,
        //   sendEmail: this.mailModal.sendEmail == "OUI" ? true : false,
        //   receptionDate: this.mailModal.receptionDate,
        //   assignmentDate: this.mailModal.assignmentDate,
        //   treatmentDate: this.mailModal.treatmentDate,
        //   outgoingMailNumber: this.mailModal.outgoingMailNumber,
        //   service: this.mailModal.service,
        //   nature: this.mailModal.nature,
        //   CEOInstruction: this.mailModal.CEOInstruction,
        //   observation: this.mailModal.observation,
        //   sinisterVictim: this.victimeId,
        //   mailDate: this.mailModal.mailDate,

        //   transmitter: this.mailModal.transmitter,

        //   file: defaultMethods.getItemId(this.Files.docs, this.file),
        //   emails: defaultMethods.getItemsEmail(
        //     this.userListe,
        //     this.mailModal.agent
        //   ),
        // };
        // alert(this.mailModal.mailID);
        if (this.mailModal._id) {
          // update

          await updateGlobalMail({
            schema: formData,
            id: this.mailModal._id,
          });

          defaultMethods.dispatchSuccess(
            this.$store,
            messages.updatedSuccessfully("Dossier")
          );
        } else {
          // add
          await createGlobalMail({ schema: formData });
          defaultMethods.dispatchSuccess(
            this.$store,
            messages.createdSuccessfully("Dossier")
          );
        }

        // this.closeMail();
        // this.initFiles();
      } catch (error) {
        defaultMethods.dispatchError(this.$store);
      }
      this.loading = false;
      this.dialog = false;
      this.initialize();
    },
    handleClickMailGed(item) {
      this.filesListe = item.files;
      // alert(JSON.stringify(this.filesListe))
      // this.adnewObjectMail.mailID = item._id;
      // this.editedIndex = this.adnewObject.indexOf(item);
      // this.adnewObject = Object.assign({}, item);
      // alert(JSON.stringify(item));
      this.addFileMailGed = true;
    },
    // async save() {
    //   this.loading = true;
    //   try {
    //     const schema = {
    //       // fileNumber: this.mailModal.fileNumber,
    //       // transmitter: this.mailModal.transmitter,
    //       // agent: this.mailModal.agent,
    //       // mailNumber: this.mailModal.mailNumber,
    //       // sendEmail: this.mailModal.sendEmail,
    //       // file: defaultMethods.getItemId(this.Files.docs, this.file),
    //       // emails: defaultMethods.getItemsEmail(
    //       //   this.Users.docs,
    //       //   this.mailModal.agent
    //       // ),
    //       // receptionDate: this.mailModal.receptionDate,
    //       // assignmentDate: this.mailModal.assignmentDate,
    //       // treatmentDate: this.mailModal.treatmentDate,
    //       // service: this.mailModal.service,
    //       // outgoingMailNumber: this.mailModal.outgoingMailNumber,
    //       // observation: this.mailModal.observation,
    //       // CEOInstruction: this.mailModal.CEOInstruction,
    //       // nature: this.mailModal.nature,
    //     };

    //     if (this.mailModal._id) {
    //       // update
    //       await updateGlobalMail({
    //         schema,
    //         id: this.mailModal._id,
    //       });
    //       defaultMethods.dispatchSuccess(
    //         this.$store,
    //         messages.updatedSuccessfully("Courier")
    //       );
    //     } else {
    //       // add
    //       await createGlobalMail({ schema });
    //       defaultMethods.dispatchSuccess(
    //         this.$store,
    //         messages.createdSuccessfully("Courier")
    //       );
    //     }
    //     this.closeMail();
    //     this.initialize();
    //   } catch (error) {
    //     defaultMethods.dispatchError(this.$store);
    //   }
    //   this.loading = false;
    // },
  },
};
</script>

<style scoped>
.btnDesign {
  color: #fff;
}

.space {
  margin-left: -100px;
  margin-right: -100px;
}

.pageTitle {
  font-size: 10px;
  font-weight: bold;
  color: #0482fb;
}

.green-bg {
  /* Set the display to `table-row` because Vuetify makes `flex` */
  display: table-row;
}

td {
  font-size: 12px !important;
  border-bottom: 1px solid #f4f7fe !important;
}

.green-bg:hover {
  /* `!important` is necessary here because Vuetify overrides this */
  background: #0482fb !important;
  color: white;
  height: 70px;
  animation: -45deg;
  cursor: pointer;
  box-shadow: inset 0 0 1em #0482fb, 0 0 2em #eeeeee;
}
</style>
